import React from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Select,
    Form,
    Typography,
    Button,
    Tag,
    DatePicker,
    Table,
    Statistic,
    Skeleton,
    Result
} from 'antd';
import {
    SearchOutlined
} from '@ant-design/icons';
import { formatPhone, convertTransactionType } from '../../utils/customFunctions';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useLocation } from 'react-router-dom';

const transactionTypeFilters = [
    { value: 'IN', label: 'รับเข้า' },
    { value: 'TRANSOUT', label: 'โอนสินค้า' },
];
const transactionStatusFilters = [
    { value: 'CREATED', label: 'อยู่ระหว่างดำเนินงาน' },
    { value: 'COMPLETED', label: 'สำเร็จ' },
    { value: 'CANCLED', label: 'ยกเลิก' },
];

const columns = [
    {
        title: 'วันที่',
        dataIndex: 'order_date',
        key: 'order_date',
        render: (text, _) => dayjs(text).format('DD-MM-YYYY')
    },
    {
        title: 'เลขที่เอกสาร',
        dataIndex: 'doc_no',
        key: 'doc_no',
    },
    {
        title: 'บริษัท',
        dataIndex: 'customer',
        key: 'customer',
        render: (text, _) => text.company
    },
    {
        title: 'เบอร์โทรศัพท์',
        dataIndex: 'customer',
        key: 'customer',
        render: (text, _) => `${formatPhone(text.phone)}${text.phone2 ? ` ; ${formatPhone(text.phone2)}` : ''}`
    },
    {
        title: 'สินค้า',
        dataIndex: 'product',
        key: 'product',
        render: (text, _) => (
            <>
                <Typography.Paragraph>{text.description ?? text.name}</Typography.Paragraph>
                <Tag color="purple">{text.category.name}</Tag>
                <Tag color="magenta">{text.brand.name}</Tag>
            </>
        )
    },
    {
        title: 'ราคา',
        dataIndex: 'price',
        key: 'price',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
        // filters: paymentTypes.map(f => ({ text: f.label, value: f.value })),
        // onFilter: (value, record) => record.payment_type.indexOf(value) === 0,
    },
    {
        title: 'ประเภท',
        dataIndex: 'transaction_type',
        key: 'transaction_type',
        render: (text, _) => convertTransactionType(text)
        // filters: paymentTypes.map(f => ({ text: f.label, value: f.value })),
        // onFilter: (value, record) => record.payment_type.indexOf(value) === 0,
    },
    {
        title: 'สถานะ',
        dataIndex: 'transaction_status',
        key: 'transaction_status',
        width: '10%',
        // filters: transactionStatus.map(f => ({ text: f.label, value: f.value })),
        // onFilter: (value, record) => record?.transaction_status.indexOf(value) === 0,
        render: (text, _) => {
            switch (text) {
                case 'COMPLETED': return <Tag color="success">สำเร็จ</Tag>
                case 'CANCLED': return <Tag color="error">ยกเลิก</Tag>
                default: return <Tag color="processing">อยู่ระหว่างดำเนินงาน</Tag>
            }
        }
    },
]

function SearchTransaction() {
    const [form] = Form.useForm();
    const redirect = useNavigate();
    const location = useLocation();
    const start_date = new URLSearchParams(location.search).get('start_date');
    const end_date = new URLSearchParams(location.search).get('end_date');
    const transaction_type = new URLSearchParams(location.search).get('transaction_type');
    const transaction_status = new URLSearchParams(location.search).get('transaction_status');
    const q = new URLSearchParams(location.search).get('q');

    let apiText = `/api/transaction/getTransactionItems?${window.location.href.split("?")[1]}`;

    const { isError, isLoading, data, error } = useQuery({
        queryKey: [apiText],
    })

    if (isLoading) {
        return <Skeleton active />
    }

    if (isError) {
        return <Result status="error" title={error.message} />
    };
    // console.log('data = ', data);
    const onSearch = e => {
        form
            .validateFields()
            .then(values => {
                // console.log(values);
                let searchText = `/admin/searchTransaction?&`;
                if (values.date) searchText += `start_date=${dayjs(values.date[0]).toISOString()}&end_date=${dayjs(values.date[1]).toISOString()}&`;
                if (values.transaction_type) searchText += `transaction_type=${values.transaction_type}&`;
                if (values.transaction_status) searchText += `transaction_status=${values.transaction_status}&`;
                if (values.q) searchText += `q=${values.q}&`;
                redirect(searchText);
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <div style={{
            background: '#fff',
        }}>

            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    <Typography.Title level={3}>
                        ค้นหา การดำเนินงาน
                    </Typography.Title>
                </Col>
                <Col xs={24} >
                    {/* <Row justify="end">
              <Col>
                <AddFormModal />
              </Col>
            </Row> */}
                </Col>
                <Divider />
                <Col xs={24} >
                    <Row justify='space-between' gutter={[0, 16]}>
                        <Col xs={24}>
                            <Row justify='space-between' gutter={[0, 16]}>
                                <Col xs={24}>
                                    <Form
                                        form={form}
                                        name="searchTransaction"
                                        layout="vertical"
                                        initialValues={{
                                            ...((start_date && end_date) && { date: [dayjs(start_date), dayjs(end_date)] }),
                                            transaction_type,
                                            transaction_status,
                                            q
                                        }}
                                    >
                                        <Row gutter={[8, 0]}>
                                            <Col xs={24} md={8}>
                                                <Form.Item name="date" label="วันที่">
                                                    <DatePicker.RangePicker
                                                        placeholder={["วันเริ่มต้น", "วันสิ้นสุด"]}
                                                        style={{ width: '100%' }} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={8}>
                                                <Form.Item name="transaction_type" label="ประเภท">
                                                    <Select
                                                        placeholder="เลือกประเภท"
                                                        showSearch
                                                        optionFilterProp="children"
                                                        allowClear
                                                    >
                                                        {transactionTypeFilters.map(t => <Select.Option key={t.value} value={t.value}>
                                                            {t.label}
                                                        </Select.Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={8}>
                                                <Form.Item name="transaction_status" label="สถานะ">
                                                    <Select
                                                        placeholder="เลือกสถานะ"
                                                        showSearch
                                                        optionFilterProp="children"
                                                        allowClear
                                                    >
                                                        {transactionStatusFilters.map(t => <Select.Option key={t.value} value={t.value}>
                                                            {t.label}
                                                        </Select.Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24}>
                                                <Row gutter={[8, 0]}>
                                                    <Col xs={24} sm={12} >
                                                        <Form.Item
                                                            label=""
                                                            name="q"
                                                        >
                                                            <Input placeholder="ค้นหา เลขที่เอกสาร ชื่อบริษัท หมายเลขโทรศัพท์" allowClear />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col >
                                                        <Button
                                                            type='primary'
                                                            icon={<SearchOutlined />}
                                                            onClick={onSearch}
                                                            style={{ width: '100%' }}
                                                        >ค้นหา</Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={24}>
                            <Table
                                rowKey={(record) => record.item_id}
                                columns={columns}
                                dataSource={data}
                                scroll={{
                                    x: 1200,
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default SearchTransaction